import React from "react";
import Accordion from 'react-bootstrap/Accordion';
import { Helmet } from "react-helmet";

import Navbar from "../components/navbar";
import Footer from "../components/footer";
import ScrollTop from "../components/scrollTop";

export default function AboutUs() {
    return (
        <>
            {/* SEO Meta Tags */}
            <Helmet>
                <meta charSet="utf-8" />
                <title>About Us</title>
                <link rel="canonical" href="https://arogyavansh.com/aboutus" />
                <meta name='description' content='Arogyavansh - About Us' />
                <meta property="og:title" content="About Us" />
                <meta property="og:description" content="Arogyavansh - About Us" />
                <meta name="twitter:title" content="About Us" />
                <meta name="twitter:description" content="Arogyavansh - About Us" />
            </Helmet>
            <Navbar manuClass="navigation-menu nav-light nav-left" containerClass="container" />

            {/* Simple header (no banner image) */}
            <section style={{ paddingTop: 'calc(80px + 2rem)', paddingBottom: '1.5rem' }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 text-center">
                            <div className="section-title">
                                <h3 className="sub-title mb-2 text-primary">About us</h3>
                                <p className="text-muted para-desc mx-auto mb-0 fs-5">
                                    ArogyaVansh brings accessible genetic healthcare to every Indian — expert consultations, education and support.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <div className="position-relative">
                <div className="shape overflow-hidden text-color-white">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                    </svg>
                </div>
            </div> */}

            {/* About Description Section */}
            <section className="">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="p-4 text-center bg-white rounded-4" data-aos="fade-up">
                                <h3 className="fw-bold text-primary mb-3">Who We Are</h3>
                                <p className="fs-5 mb-3 text-dark">
                                    <span className="fw-bold text-primary">ArogyaVansh</span> is on a mission to make genetic healthcare accessible to every Indian. Our certified geneticists and healthcare professionals are dedicated to providing expert care, education, and support to patients and families across the country.
                                </p>
                                <p className="fs-5 mb-0 text-dark">
                                    Founded in <span className="fw-bold text-primary">2024</span>, we have already helped thousands of patients access vital genetic and hematology consultations. Our mission is to bridge the gap in genetic healthcare, ensuring that everyone—regardless of location or economic status—can benefit from advances in genetic medicine.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Why Choose Section */}
            <section className="section py-5 bg-soft-primary">
                <div className="container">
                    <div className="row justify-content-center mb-4">
                        <div className="col-lg-8">
                            <div className="section-title text-center" data-aos="fade-up">
                                <span className="badge rounded-pill bg-primary mb-3">Why Choose ArogyaVansh?</span>
                                <h3 className="title mb-3 text-primary">Why Choose ArogyaVansh?</h3>
                                <p className="text-muted para-desc mx-auto mb-0 fs-5">
                                    Experience the future of genetic healthcare with our unique advantages.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row g-4 justify-content-center">
                        <div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="100">
                            <div className="why-feature h-100 text-center p-4 rounded-4 shadow-sm bg-white">
                                <div className="mb-3 fs-1 animate-bounce">🏠</div>
                                <h5 className="mb-2">Virtual Consultations</h5>
                                <p className="text-muted mb-0">Connect with certified geneticists from the comfort of your home. Save time, money, and stress.</p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="200">
                            <div className="why-feature h-100 text-center p-4 rounded-4 shadow-sm bg-white">
                                <div className="mb-3 fs-1 animate-bounce">🇮🇳</div>
                                <h5 className="mb-2">Pan-India Accessibility</h5>
                                <p className="text-muted mb-0">Expert genetic care is now available in every corner of India. Urban or rural, we've got you covered.</p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="300">
                            <div className="why-feature h-100 text-center p-4 rounded-4 shadow-sm bg-white">
                                <div className="mb-3 fs-1 animate-bounce">💻</div>
                                <h5 className="mb-2">User-Friendly Platform</h5>
                                <p className="text-muted mb-0">Book appointments easily and enjoy secure video consultations with our intuitive interface.</p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="400">
                            <div className="why-feature h-100 text-center p-4 rounded-4 shadow-sm bg-white">
                                <div className="mb-3 fs-1 animate-bounce">🩺</div>
                                <h5 className="mb-2">Comprehensive Care</h5>
                                <p className="text-muted mb-0">Receive personalized genetic counseling, testing guidance, and a free follow-up consultation.</p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="500">
                            <div className="why-feature h-100 text-center p-4 rounded-4 shadow-sm bg-white">
                                <div className="mb-3 fs-1 animate-bounce">📚</div>
                                <h5 className="mb-2">Education & Awareness</h5>
                                <p className="text-muted mb-0">Access resources to understand genetic conditions better. We empower you with knowledge.</p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="600">
                            <div className="why-feature h-100 text-center p-4 rounded-4 shadow-sm bg-white">
                                <div className="mb-3 fs-1 animate-bounce">💰</div>
                                <h5 className="mb-2">Affordable Pricing</h5>
                                <p className="text-muted mb-0">Transparent fees make genetic healthcare accessible to more Indians than ever before.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* FAQ Section */}
            <section className="section py-5">
                <div className="container">
                    <div className="row justify-content-center mb-4">
                        <div className="col-lg-8">
                            <div className="section-title text-center" data-aos="fade-up">
                                <span className="badge rounded-pill bg-primary mb-3">FAQs</span>
                                <h3 className="title mb-3 text-primary">Frequently Asked Questions</h3>
                                <p className="text-muted para-desc mx-auto mb-0 fs-5">
                                    Answers to some of the most common questions about our platform and services.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <Accordion>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>How much does a consultation cost?</Accordion.Header>
                                    <Accordion.Body>
                                        Our consultation fees are transparent and competitive. Please check our pricing page for current rates.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>Is my personal information secure?</Accordion.Header>
                                    <Accordion.Body>
                                        Absolutely. We use state-of-the-art encryption and follow strict privacy protocols to protect your data.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>Do I need any special equipment for the video consultation?</Accordion.Header>
                                    <Accordion.Body>
                                        Just a smartphone, tablet, or computer with a camera and internet connection is sufficient.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>Can I get a prescription through ArogyaVansh?</Accordion.Header>
                                    <Accordion.Body>
                                        Yes, our geneticists can provide prescriptions when necessary, in accordance with telemedicine guidelines.
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>What if I need genetic testing?</Accordion.Header>
                                    <Accordion.Body>
                                        Our experts will guide you on the appropriate tests and can help interpret the results in a follow-up consultation.
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
            <ScrollTop />
        </>
    )
}